import { render } from "./LoadingPage.vue?vue&type=template&id=4691ae3a"
import script from "./LoadingPage.vue?vue&type=script&lang=js"
export * from "./LoadingPage.vue?vue&type=script&lang=js"
script.render = render

export default script